export const borderRadiusPalette = {
  one: '24px',
  two: '16px',
  three: '8px',
  four: '4px',
  five: '0px'
};
